import React, { useState, useRef }  from 'react';
import './App.css';

import packageJSON from '../package.json'; // get version

// My libraries
import * as mediaUtils from  './lib/mediaDeviceUtils.js';
import StreamRecorder from './lib/StreamRecorder.js';
import InputAudioEffects from './lib/InputAudioEffects.js';
import AudioFileToMediaStreamTrack  
   from './lib/AudioFileToMediaStreamTrack.js';
import VideoFileToStream from './lib/VideoFileToStream.js';
// import AudioStreamWavRecorder
//   from './lib/AudioStreamWavRecorder.js';
import AudioStreamEQ from './lib/AudioStreamEQ.js';
// import RTPStatistics from './lib/RTPStatistics.js';
import RTPStatistics from './lib/RTPStatistics2.js';

// skyway SDK
import Peer from 'skyway-js'; 
import KEY from './SkyWay-key.json';

// Global constants
import {GLOBAL} from './lib/GLOBAL.js';

// debug
const newFeature = false;
const useStat = true;

function App() {

  // states
  const [isInitialized, setIsInitialized] = useState(false);
  // Inputs
  const [videoInputDevices, setVideoInputDevices]
       = useState({list: [], checked: []});
  const [audioInputDevices, setAudioInputDevices] 
       = useState({list: [], checked: []});
  const [audioOutputDevices, setAudioOutputDevices] = useState([]);
  // mic
  const [autoGain, setAutoGain] = useState(false);
  const [echoCancellation, setEchoCancellation] = useState(false);
  const [comp, setComp] = useState(false);
  const [micGain, setMicGain] = useState(0); // in dB
  const [meterValue, setMeterValue] = useState(-100); 
  const [meterPeak, setMeterPeak] = useState(GLOBAL.meterPeakHold); 

  // transmission
  const [localVideoEnabled, setLocalVideoEnabled] = useState([true,true]); 
  const [kbps, setkbps] = useState({video: 500, audio: 256}); 

  // RTC connection states
  const [localPeerId, setLocalPeerId] = useState('');
  const [remotePeerId, setRemotePeerId] = useState('');
  const [peerList, setPeerList] = useState([]);
  const [peerState, setPeerState] = useState('closed');
  const [callState, setCallState] = useState('idle');
   // Button: Wait =(ready)==> Call = (conn)=> Hangup =(closed) => Call
   // (state):                  
   //          Call =(called)=> Answer =(conn)=> Hangup =(closed) => Call


  // statistics
  const [statText, setStatText] = useState('');

  // Recorders
  const [isVideoRecording, setIsVideoRecording] = useState(false);

  // DOM references
  const callButton = useRef();
  const localVideo01 = useRef();
  const localVideo02 = useRef();
  const remoteVideo01 = useRef();
  const remoteVideo02 = useRef();
  const localPlayback = useRef();
  const remotePlayback = useRef();

  const peakMeter = useRef();

  async function constructor() {
    console.log("CONSTRUCTOR");
    if (isInitialized) return;
    setIsInitialized(true);

    try {
      await getMediaDeviceList();
    } catch (err) {console.error(err);}

    navigator.mediaDevices.ondevicechange = getMediaDeviceList;

  } // end constructor

  const getMediaDeviceList = async () => {

    const newList = await mediaUtils.getMediaDeviceList();
    console.log('getMediaDeviceList()',newList);

    let devList, pDevices, pChecked = [], newChecked = [];

    /* set videodevices list and checkbox checked */
    pDevices = videoInputDevices.list;
    pChecked = videoInputDevices.checked;
    devList =  newList.videoInputDevices;

    devList.forEach ((newDeviceInfo,index) => {
      const found = pDevices.findIndex((device) => {
        return device.deviceId === newDeviceInfo.deviceId;
      });
      if(found >= 0) newChecked[index] = pChecked[found];
      else newChecked[index] = false;
    });

    setVideoInputDevices(
      {list: [...newList.videoInputDevices], checked: [...newChecked]});

    /* set audiodevices list and checkbox checked */
    pDevices = audioInputDevices.list;
    pChecked = audioInputDevices.checked;
    devList =  newList.audioInputDevices;
    newChecked = [];

    devList.forEach ((newDeviceInfo,index) => {
      const found = pDevices.findIndex((device) => {
        return device.deviceId === newDeviceInfo.deviceId;
      });
      if(found >= 0) newChecked[index] = pChecked[found];
      else newChecked[index] = false;
    });

    setAudioInputDevices(
      {list: [...newList.audioInputDevices], checked: [...newChecked]}
    );

    // Safari does not support audioOutputdevice
    setAudioOutputDevices([...newList.audioOutputDevices]); 

    return;
  }

  const handleVideoDeviceSelection = async (e, index) => {
    if (e.target.name !== 'video') return;

    const deviceId = e.target.value;
    const newList = {
       list: videoInputDevices.list, checked: videoInputDevices.checked };

    if (videoInputDevices.checked[index]){
      console.log('Off', deviceId);
      stopSourceTrack(deviceId);
      newList.checked[index] = false;

    } else {
      console.log('On', deviceId);
      const videoconstraints = GLOBAL.defaultVideoConstraints;
      videoconstraints.deviceId = {exact: deviceId};
      const videoTrack = await mediaUtils.getCameraTrack(videoconstraints)

      if (newFeature && GLOBAL.mediaConnection && GLOBAL.mediaConnection.open){
        GLOBAL.mediaConnection.addTrack(videoTrack);
        GLOBAL.RTPStatistics.push({
          type: 'event',
          timeStamp: Date.now(),
          message: 'addTrack camera'
        });
      }

      GLOBAL.localVideoTrack.push(videoTrack);

      if (!localVideo01.current.srcObject) 
        localVideo01.current.srcObject = new MediaStream([videoTrack]);
      else if(!localVideo02.current.srcObject)
        localVideo02.current.srcObject = new MediaStream([videoTrack]);
      else { console.error ('max 2 videos');}
      newList.checked[index] = true;
    }

    setVideoInputDevices({list: [...newList.list], 
      checked: [...newList.checked]});

    return;
  };

  const handleAudioDeviceSelection = async (e, index) => {

    if (e.target.name !== 'audio') return;

    GLOBAL.audioCtx.resume();
    const deviceId = e.target.value;

    const newList = {list: audioInputDevices.list, 
         checked: audioInputDevices.checked }; 
    // reference does not work for state update

    if (audioInputDevices.checked[index]){
      console.log('Off', deviceId);
      stopSourceTrack(deviceId);
      newList.checked[index] = false;
    } else {
      console.log('On', deviceId);
      try {
        const micTrack = await openMicTrack(deviceId);
        const inputAudioEffects 
          = new InputAudioEffects(
            GLOBAL.audioCtx,
            new MediaStream([micTrack]),meterCallback);
        GLOBAL.inputAudioEffects = inputAudioEffects;
        const processedTrack = inputAudioEffects.getOutputTrack();

        if (newFeature && GLOBAL.mediaConnection 
            && GLOBAL.mediaConnection.open){
          GLOBAL.mediaConnection.addTrack(processedTrack);
          GLOBAL.RTPStatistics.push({
            type: 'event',
            timeStamp: Date.now(),
            message: 'addTrack audio' 
          });
        }

        GLOBAL.localAudioTrack.push(processedTrack);
 
      } catch (e) {console.error(e);}

      newList.checked[index] = true;
    }

    setAudioInputDevices(
        {list: [...newList.list], checked: [...newList.checked]});
    return;
}

const openMicTrack = async (deviceId) => {
  const audioConstraints = GLOBAL.defaultAudioConstraints;
  // console.log(audioConstraints);
  audioConstraints.deviceId = {exact: deviceId}; 
  return await mediaUtils.getMicTrack(audioConstraints);
}

const stopSourceTrack = ((deviceId) => {

 // Video track
  const vIndex = GLOBAL.localVideoTrack.findIndex((element) =>
    element.getSettings().deviceId === deviceId
  );

  const tmp = [localVideo01.current,localVideo02.current];

  tmp.forEach( (player) => {
    if (!player.srcObject) return;
    const vTrack = player.srcObject.getVideoTracks()[0];
    if (vTrack.getSettings().deviceId === deviceId) player.srcObject = null;
  });

  if (vIndex >= 0){
    const tracks = GLOBAL.localVideoTrack;
    if (newFeature && GLOBAL.mediaConnection 
      && GLOBAL.mediaConnection.open) {
      GLOBAL.mediaConnection.removeTrack(tracks[vIndex]);
      // console.log('remove video track via mediaConnection', vIndex);
      GLOBAL.RTPStatistics.push({
        type: 'event',
        timeStamp: Date.now(),
        message: 'removeTrack video'
      });
    }

    tracks[vIndex].stop();
    tracks.splice(vIndex,1);
  } 

 // Audio track
  const tracks = GLOBAL.localAudioTrack;
  const aIndex = tracks.findIndex((element) =>
    element.getSettings().deviceId === deviceId);

  if (aIndex >= 0) {

    if (newFeature && GLOBAL.mediaConnection 
       && GLOBAL.mediaConnection.open) {
      GLOBAL.mediaConnection.removeTrack(tracks[aIndex]);
      GLOBAL.RTPStatistics.push({
          type: 'event', 
          timeStamp: Date.now(),
          message: 'removeTrack mic'
      });
    } // newFeature

    if (GLOBAL.inputAudioEffects) { // find and close effect track
      const id = GLOBAL.inputAudioEffects.getOutputTrack().id;
      const aIndex = GLOBAL.localAudioTrack.findIndex( element => 
      element.id === id);

      console.log('stopping processed track');
      GLOBAL.inputAudioEffects.close(); 
        // source micTrack is stopped in close()
      GLOBAL.inputAudioEffects = null;
      tracks.splice(aIndex,1);
    } // if inputAudioEffects

  } // end if aIndex

 }); // End stopSourceTrack

  const handleMicGain = (event) => {
    const gain = parseFloat(event.target.value);
    setMicGain(gain);
    if (GLOBAL.inputAudioEffects) GLOBAL.inputAudioEffects.setGain(gain);
  };

  const meterCallback = (peakPowerDB) => {
    setMeterValue(peakPowerDB);   
    if (peakPowerDB > GLOBAL.meterPeakHold)  
       GLOBAL.meterPeakHold = peakPowerDB;
    setMeterPeak (GLOBAL.meterPeakHold);
  };

  const handleRemoteCall = async (e) => {
    if(GLOBAL.audioContext) GLOBAL.audioContext.resume();

    if (e.target.name !== 'remoteCall') return;

    console.log('handleRemoteCall() ', callState);

    GLOBAL.localVideoTrack.forEach( track => {
      if (track.constructor.name === 'MediaStreamTrack')
      GLOBAL.sendingStream.addTrack(track);
    });
    GLOBAL.localAudioTrack.forEach( track => { 
      if (track.constructor.name === 'MediaStreamTrack')
      GLOBAL.sendingStream.addTrack(track);
    });

    switch (callState) {
      case 'ready': break; // --> Call 
      case 'connected': // --> Hangup
        GLOBAL.mediaConnection.close();
        setCallState('ready');
        return;
      case 'called':
        const answerOptions = {
          videoBandwidth: kbps.video, 
          audioBandwidth: kbps.audio,
          audioCodec: 'opus'
        };

        GLOBAL.mediaConnection.answer(GLOBAL.sendingStream, answerOptions);

        setCallState('connected'); 
        GLOBAL.audioCtx.resume();
        return;
      default: return;
    }

    const peer = GLOBAL.skyWayPeer;
    if (!remotePeerId) return;

    console.log('set sending stream before CALL', 
      GLOBAL.sendingStream.getTracks());

    const callOptions = {
            videoBandwidth: kbps.video,
            audioBandwidth: kbps.audio,
            audioCodec: 'opus'
          };

    const mediaConnection 
          = peer.call(remotePeerId, GLOBAL.sendingStream, callOptions);
          // = peer.call(remotePeerId, GLOBAL.sendingStream);

    GLOBAL.mediaConnection = mediaConnection;
    setCallState('connected');

    const dataConnection = peer.connect(remotePeerId);
    GLOBAL.dataConnection = dataConnection;

    dataConnection.on('open', () => {
      console.log('Caller data connection open');
    });

    dataConnection.on('data', (data) => {
      console.log('Caller recvd data', data.name, data.msg);
      switch(data.name){
        case 'command': 
          processCommand(data.msg); 
          break;
        default:
          console.error('unknown data.name', data.name);
      }
    });

    dataConnection.on('close', () => {
      console.log('Caller data connection close');
    });

    dataConnection.on('error', (error) => {
      console.error('Caller dataConnection error',error);
    });

    mediaConnection.on('stream', (stream) => {

      GLOBAL.receivingStream = stream;
      console.log('Caller got stream');
      // return; // debug

      playReceivingStream();

      stream.onaddtrack = e => {
        console.log('Caller stream.onaddtrack',e);
        GLOBAL.receivingStream.addTrack(e.track);
        playReceivingStream();
      } 

      stream.onremovetrack = e => {
        console.log('Caller stream.onremovetrack',e);
        e.track.stop();
        playReceivingStream();
      } 

      GLOBAL.rtcPeer = mediaConnection.getPeerConnection();
      console.log('Caller RTCPeer', GLOBAL.rtcPeer);

      if (useStat && !GLOBAL.RTPStatInstance) {
        GLOBAL.RTPStatInstance = new RTPStatistics(
          GLOBAL.rtcPeer,
          10.0, // sec
          showRTPStat, // callback
          // GLOBAL.RTPStatistics
        );
        GLOBAL.RTPStatInstance.start();
      }

    });

    mediaConnection.on('close', () => {
      console.log('Caller mediaConnection close event');
      releasePlayers();
      setCallState('ready');
    });

  };
  
  const processCommand = (msg) => {
    // {op, device, enabled(0/1)
    switch(msg.op){
      case 'enable':
        if (msg.device === 'video01'){
          if (msg.enabled) remoteVideo01.current.style.display = '';
          else remoteVideo01.current.style.display = 'none';
        }
        if (msg.device === 'video02'){
          if (msg.enabled) remoteVideo02.current.style.display = '';
          else remoteVideo02.current.style.display = 'none';
        }
      break;
      case 'closeMedia':
        GLOBAL.mediaConnection.close();
        setCallState('ready');
      break;
      default:
        console.log('undefined op', msg.op);
    }
  }

  const releasePlayers = () => {
    console.log('releasePlayers()');
    GLOBAL.remoteVideoTrack.forEach(track => track.stop());
    GLOBAL.remoteAudioTrack.forEach(track => track.stop());
    if(remoteVideo01.current) remoteVideo01.current.srcObject = null;
    if(remoteVideo02.current) remoteVideo02.current.srcObject = null;
    GLOBAL.audioPlayer.forEach(player => {
      player.pause(); player.srcObject = null; player = null;
    });
    GLOBAL.audioPlayer = [];
    GLOBAL.remoteVideoTrack = [];
    GLOBAL.remoteAudioTrack = [];
    GLOBAL.receivingStream = null;
  };

  const playReceivingStream = () => {
    console.log('playReceivingStream');
    const stream = GLOBAL.receivingStream;

    const videoTracks = [];
    const audioTracks = [];

    stream.getTracks().forEach (track => {
      if (track.kind === "audio" && track.enabled) audioTracks.push(track);
      if (track.kind === "video" && track.enabled) videoTracks.push(track);
    });

    console.log('receiving video', videoTracks, 'audio', audioTracks);

    for (let i = 0; i < videoTracks.length; i++){
      const track = videoTracks[i]; 
      GLOBAL.remoteVideoTrack[i] = track;
      if (i === 0){
        remoteVideo01.current.srcObject = new MediaStream([track]);
      } else if (i === 1) {
        remoteVideo02.current.srcObject = new MediaStream([track]);
      }
    }

    for (let i = 0; i < audioTracks.length; i++){
      const track = audioTracks[i]; 
      GLOBAL.remoteAudioTrack[i] = track;

      if (i === 0){
        console.log('audio player1');
        const player1 = new Audio();
        GLOBAL.audioPlayer[i] = player1; 
/*
        const eq = new AudioStreamEQ(null,track);
        const stream = eq.getOutputStream();
        player1.srcObject = stream; 
*/
        player1.srcObject = new MediaStream([track]);
        player1.oncanplay = () => player1.play();

      } else if (i === 1) {
        const player2 = new Audio();
        GLOBAL.audioPlayer[i] = player2; 
        player2.srcObject = new MediaStream([track]);
        player2.oncanplay = () => player2.play();
      }
    }

  }; // End function

  const getMyPeerId = () => { // called twice in dev mode

    console.log('getMyPeerId()');

    const options = {
      key: KEY[0].APIKey, 
      config: GLOBAL.peerDefaultConfig,
      debug: 2 // 0(none),1(error),2(warn),3(log)
    };

    if (GLOBAL.skyWayPeer) {
      GLOBAL.skyWayPeer.destroy();
      GLOBAL.skyWayPeer = undefined;
      console.log ('peer destroy()');
    } 


    if (localPeerId) {
      console.log ('new Peer with last localPeerId');
      GLOBAL.skyWayPeer = new Peer(localPeerId,options);
    } else { 
      console.log ('new Peer');
      GLOBAL.skyWayPeer = new Peer(options);
    }

    const peer = GLOBAL.skyWayPeer;

    peer.on('open', () => {
      setLocalPeerId(peer.id);
      console.log('Local: got localPeerId:', peer.id); 
      peer.listAllPeers((peers) => { 
        const found = peers.filter((id) => id !== peer.id);
        console.log('remotePeer candidates', found); 
        setPeerList(found.join(', '));
      });
      setCallState('ready');
      setPeerState('open');
    });

    peer.on('call', async (mediaConnection) => {
      console.log('Callee call(ed)');

      GLOBAL.mediaConnection = mediaConnection;
      GLOBAL.rtcPeer = mediaConnection;
      GLOBAL.remotePeerId = mediaConnection.remoteId;

      setRemotePeerId(mediaConnection.remoteId);
      console.log('remotePeerId', mediaConnection.remoteId);

      setCallState('called');

      // accept call by button click

      mediaConnection.on('stream', stream => {
        console.log('Callee: got stream', stream.getTracks());
        GLOBAL.receivingStream = stream;
        playReceivingStream();

        stream.onaddtrack = e => {
          console.log ('Callee stream.onaddtrack', e);
          GLOBAL.receivingStream.addTrack(e.track);
          playReceivingStream();
        }

        stream.onremovetrack = e => {
          console.log ('Callee stream.onremovetrack', e);
        }

       GLOBAL.rtcPeer = mediaConnection.getPeerConnection();

       if (useStat && !GLOBAL.RTpStatInstance) {
          GLOBAL.RTPStatInstance = new RTPStatistics(
            GLOBAL.rtcPeer,
            10.0, // sec
            showRTPStat // callback
          );
          GLOBAL.RTPStatInstance.start();
        }

      });

      mediaConnection.on('close', () => {
        console.log('Callee mediaConnection close');
        releasePlayers();
        setCallState('ready');
        if (GLOBAL.RTPStatInstance) {
          GLOBAL.RTPStatInstance.stop();
          GLOBAL.RTPStatInstance.export(GLOBAL.RTPStatistics);
        }
      });

    });

    peer.on('close', () => {
      console.log('Peer: peer close event');
      if (GLOBAL.RTPStatInstance) {
        GLOBAL.RTPStatInstance.stop();
        GLOBAL.RTPStatInstance.export(GLOBAL.RTPStatistics);
      }
      setCallState('ready');
    });

    peer.on('connection', (dataConnection) => {
      console.log('Callee got data connection');
      GLOBAL.dataConnection = dataConnection;

      dataConnection.on('open', () => {
        console.log('Callee: dataConnection open');
      }); 

      dataConnection.on('data', (data) => {
        console.log('Callee: received data', data);
        switch(data.name){
          case 'command': processCommand(data.msg); break;
          default: console.error('unknown data.name', data.name);
        }
      }); 

      dataConnection.on('close', () => {
        console.log('Callee dataConnection close');
      }); 

      dataConnection.on('error', (error) => {
        console.log('Callee: dataConnection error', error);
      }); 

    });

    peer.on('error', (error) => {
      console.log('Caller: Error', error);
    });

  }; 

  const toggleVideo = (e) => {

    if (e.target.value === 'localVideo01') { 
      if (!localVideo01.current.srcObject) return;
      const track = localVideo01.current.srcObject.getTracks()[0];
      track.enabled = !track.enabled;
      const videoEnabled = [...localVideoEnabled];
      videoEnabled[0] = track.enabled;
      setLocalVideoEnabled(videoEnabled);
      console.log('videoEnabled', localVideoEnabled);

      GLOBAL.RTPStatistics.push({ 
        type: 'event',
        timestamp: Date.now(),
        event: 'localVideo01 ' + track.enabled
      });

      const msg = {op: 'enable', device: 'video01', enabled: track.enabled};
      if (GLOBAL.dataConnection)
        GLOBAL.dataConnection.send({name:'command', msg: msg});
    } 

    if (e.target.value === 'localVideo02') { 
      if (!localVideo01.current.srcObject) return;
      const track = localVideo02.current.srcObject.getTracks()[0];
      track.enabled = !track.enabled;
      const videoEnabled = [...localVideoEnabled];
      videoEnabled[1] = track.enabled;
      setLocalVideoEnabled(videoEnabled);
      console.log('videoEnabled', localVideoEnabled);

      GLOBAL.RTPStatistics.push({ 
        type: 'event',
        timestamp: Date.now(),
        event: 'localVideo02 ' + track.enabled});

      const msg = {op: 'enable', device: 'video02', enabled: track.enabled};
      if (GLOBAL.dataConnection)
        GLOBAL.dataConnection.send({name:'command', msg: msg});
    } 

  } 

  const handleVideoRecorder = (e) => {
    console.log('handleVideoRecorder');
    if (e.target.name === 'start'){
       if (isVideoRecording){
         console.log('stop video stream recorder');
         GLOBAL.txVideoRecorder.stop();
         setIsVideoRecording(false);
       } else if (GLOBAL.sendingStream.getTracks().length > 0) { 
         console.log('start video stream recorder');
         GLOBAL.txVideoRecorder = new StreamRecorder(GLOBAL.sendingStream);
         GLOBAL.txVideoRecorder.start();
         setIsVideoRecording(true);
       }

    }

    if (e.target.name === 'export' && GLOBAL.txVideoRecorder) 
       GLOBAL.txVideoRecorder.exportFile('sendingStream');
  }

  const handleId = (e) => {
     if (e.target.name === 'remotePeerId') {
       setRemotePeerId(e.target.value);
     }
  };


// main
  if (!isInitialized) constructor();

  const switchButton = () => {
    switch(callState){
      case 'idle': return 'Wait';
      case 'ready': return 'Call';
      case 'called': return 'Answer';
      case 'connected': return 'hangUp';
      default:
    }
  }; 

  const handlePeerOpenClose = () => {
    if (peerState === 'closed') getMyPeerId();
    else if (GLOBAL.skyWayPeer) {
      GLOBAL.skyWayPeer.destroy();
      console.log('Peer destroy()');
      setPeerState('closed');
    }
  }

  const playVideoFile = async (e) => {
    if (e.target.name === 'loadFile'){
      const player 
        = new VideoFileToStream(e.target.files[0], localPlayback.current);
    }
  };

  const playAudioFile = async (e) => {

    if (e.target.name === 'loadFile'){
      if (GLOBAL.filePlayer) GLOBAL.filePlayer = undefined;
      const player 
        = new AudioFileToMediaStreamTrack(GLOBAL.audioCtx,e.target.files[0]);
      GLOBAL.filePlayer = player
      const ret = await player.getOutputTrack();
      const track = ret.track;
/*
      GLOBAL.txAudioRecorder 
        = new AudioStreamWavRecorder(GLOBAL.audioCtx,track,ret.sampleRate); 
      console.log('new AudioStreamWavRecorder');
*/
      
      console.log('File Player added to sending stream');
      GLOBAL.localAudioTrack.push(track);

      if (newFeature && GLOBAL.mediaConnection && GLOBAL.mediaConnection.open){
        GLOBAL.mediaConnection.addTrack(track);
        GLOBAL.RTPStatistics.push({
          type: 'event',
          timeStamp: Date.now(),
          message: 'addTrack audioFile player'
        });
      }

      console.log(track);
    }

    if (e.target.name === 'play'){
      if(GLOBAL.filePlayer) GLOBAL.filePlayer.play();
    }

    if (e.target.name === 'stop'){
      if(GLOBAL.filePlayer) GLOBAL.filePlayer.stop();
    }

  };

  const handleBps = (e) => {

    if (e.key !== 'Enter') {
      // console.log('key', e.key);
      return;
    }

    let newVal = undefined;

    if (e.target.name === 'video'){ 
      newVal = {
         video: parseInt(e.target.value), 
         audio: kbps.audio
      };
    }
    if (e.target.name === 'audio'){ 
      newVal = {
         video: kbps.video,
         audio: parseInt(e.target.value)
      };
    }

    setkbps(newVal);

    if (newFeature && GLOBAL.mediaConnection && GLOBAL.mediaConnection.open)
      GLOBAL.mediaConnection.setBandwidth(newVal);

  };

  const setMicEffects = (e) => {
    const name = e.target.name;
    if (name === 'autoGain'){
      GLOBAL.inputAudioEffects.setAutoGain(!autoGain);
      setAutoGain(!autoGain);
    }

    if (name === 'echoCancellation'){
      GLOBAL.inputAudioEffects.setEchoCancellation(!echoCancellation);
      setEchoCancellation(!echoCancellation);
    }

    if (name === 'comp'){
      GLOBAL.inputAudioEffects.setComp(!comp);
      setComp(!comp);
    }
  }; 

  const showRTPStat = (newStat) => { // callback function for Statistics
    try {
      GLOBAL.RTPStatistics.push('-------',...newStat);
      const tmp = GLOBAL.RTPStatistics;
      const last10 = tmp.slice(Math.max(0,tmp.length - 10), tmp.length);
      const message = last10.map( (element,index) => {
        return <div>{JSON.stringify(element,null,'\t')}</div>;
      });
      setStatText(message);
    } catch (e) {
      console.error(e);
    }

  };


/* User interface */
  return (
    <div className="App">
    <h3>WebRTC client &emsp; <button name="peerOpenClose" 
        onClick={handlePeerOpenClose} >
      {peerState === 'closed' ? 'Open' : 'Close' }</button></h3>
     video (max kbps):&nbsp; <input type="text" 
         name="video" onKeyPress={handleBps}/> (set: {kbps.video})
     &emsp; 
     audio (max kbps):&nbsp; <input type="text" 
         name="audio" onKeyPress={handleBps}/> (set: {kbps.audio})
    <hr/>
    localPeerId: &nbsp; "{localPeerId}" &emsp;
    remotePeerId (copy &amp; paste): &nbsp;
    <input type="text" width="20" name="remotePeerId" 
    value={remotePeerId} onChange={handleId} />
    &emsp; 
    <button ref={callButton} name="remoteCall" value={callState} 
     onClick={handleRemoteCall}>
    {switchButton()}
    </button>
    <hr/>peerList (probably the last one): &emsp; {peerList}
<hr/>
 <div>
    Video Input (max 2): &emsp;
    {videoInputDevices.list.map((deviceInfo,index) => 
      <span key={index}>
       <label>
        <input type="checkbox" name="video" 
        value={deviceInfo.deviceId} 
        checked={videoInputDevices.checked[index]} 
        onChange={(e) => handleVideoDeviceSelection(e,index)} />
        {deviceInfo.label} (Group: ...{deviceInfo.groupId.slice(-10)})
       </label>
     </span>
    )}
  </div>
  <br/>
  <div>
    Audio Input (max one for Firefox): &emsp;
    {audioInputDevices.list.map((deviceInfo,index) => 
     <span key={index}>
       <label>
        <input type="checkbox" name="audio" 
        value={deviceInfo.deviceId}
        checked = {audioInputDevices.checked[index]}
        onChange={(e) => handleAudioDeviceSelection(e,index)} />
       {deviceInfo.label} (Group: ...{deviceInfo.groupId.slice(-10)})
       </label>
     </span>
    )}
   </div>
<hr/>
  Sending video stream recorder: &emsp;
  <button name="start" onClick={handleVideoRecorder} >
  {isVideoRecording ? 'Stop' : 'Start'}</button>
  &emsp; 
  <button name="export" onClick={handleVideoRecorder}>
  Export</button>
<hr/>
<div>
<div>
Send Audio file : &nbsp; 
<button name='play' onClick={playAudioFile} >Play</button>&emsp;
<button name='stop' onClick={playAudioFile} >Stop</button>&emsp; |
&emsp;
<input type="file" name="loadFile" size="40"
   accept="audio/*,.wav,.mp3,.aac,.m4a,.opus,.webm" 
   onChange={playAudioFile}/>
</div>
<br/>
<div>
Send Video file (TBD) : &nbsp; 
<button name='play' onClick={playVideoFile} >Play</button>&emsp;
<button name='stop' onClick={playVideoFile} >Stop</button>&emsp; |
&emsp;
<input type="file" name="loadFile" size="40"
   accept="video/*,.mp4,.webm" onChange={playVideoFile}/>
</div>
</div>
<hr/>
<div>
     MicGain (dB): &emsp;<input type='range' name='micGain'
         min={-24} max={24} step={1}
         value ={micGain} onChange = {handleMicGain} 
         style={{width: '20%'}} /> 
       &nbsp;{ micGain >= 0 ? 
          "+" + ('0000' + Math.abs(micGain)).slice(-2)
          : "-" + ('0000' + Math.abs(micGain)).slice(-2) }
       &emsp; 
       <button name="autoGain"
       style ={{backgroundColor: autoGain ? "#00ee00" : "#dddddd"}}
       onClick={setMicEffects}>AutoGain</button>&emsp; 
       <button name="echoCancellation"
       style ={{backgroundColor: echoCancellation ? "#00ee00" : "#dddddd"}}
       onClick={setMicEffects}>echoCancellation</button>&emsp;
       <button name="comp"
       style ={{backgroundColor: comp ? "#00ee00" : "#dddddd"}}
       onClick={setMicEffects}>Comp</button><br/>
     &nbsp; <button 
          onClick={(e) => GLOBAL.meterPeakHold = -60}>Reset peak</button>
     &nbsp;&nbsp;-64&nbsp;
     <meter ref={peakMeter} min={-64} high={-3} max={10} value={meterValue}
     style={{width: '20%'}}></meter>&nbsp;10, Peak {meterPeak.toFixed(1)}
</div>
<hr/>

<div>
<table border="2">
<tbody>
    <tr>
    <td>&nbsp;<b>localVideo01</b>&emsp; 
    <button name="disableVideo" value="localVideo01" onClick={toggleVideo}>
    {localVideoEnabled[0] ? 'Disable' : 'Enable'}</button></td>
    <td>&nbsp;<b>remoteVideo01</b></td>
    <td>&nbsp;<b>RTP Statistics</b></td>
    </tr>
   <tr><td>
    <video ref={localVideo01} autoPlay playsInline muted
      style={{width: '480px'}} /></td>
    <td><video ref={remoteVideo01} autoPlay playsInline muted
      style={{width: '480px'}} /></td>
    <td rowSpan='5' valign='top'>{statText}</td>
   </tr>

   <tr><td>&nbsp;<b>localVideo02</b> &emsp;
    <button name="disableVideo" value="localVideo02" onClick={toggleVideo}>
    {localVideoEnabled[1] ? 'Disable' : 'Enable'}</button></td>
   <td>&nbsp;<b>remoteVideo02</b></td>
   </tr>
    <tr>
    <td><video ref={localVideo02} autoPlay playsInline muted
      style={{width: '480px'}} /></td>
    <td><video ref={remoteVideo02} autoPlay playsInline muted
      style={{width: '480px'}} /></td>
    </tr>
    <tr><td><b>local Playback</b></td>
    <td>&nbsp;<b>remote Playback</b></td>
    </tr>
    <tr>
    <td><video ref={localPlayback} playsInline controls
      style={{width: '480px'}} /></td>
    <td><video ref={remotePlayback} autoPlay playsInline muted
      style={{width: '480px'}} /></td>
    </tr> 
</tbody>
</table>

{/*
<table>
<tr><th>RTP Statistics</th></tr>
<tr><td>
<pre>
{statText}
</pre>
</td></tr>
</table>
*/}

</div>
<hr/>
<div>
Version: {packageJSON.version}
</div>
</div>
  );
}

export default App;
